export function composePromises(...promises) {
  return promise => {
    return promises.reduce((acc, val) => {
      return acc.then(val);
    }, Promise.resolve(promise));
  };
}
